<template>
    <v-layout row justify-center >
        <v-dialog v-model="dialogModalDetailEmp" fullscreen hide-overlay  persistent transition="dialog-bottom-transition">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>Informations personnelles et professionnelles</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <v-btn icon dark @click="closeDialog()">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-toolbar-items>
                </v-toolbar>
                <v-layout row>
                    <v-flex xs12 class="pt-2 pr-2 pb-2 pl-2">
                        <detailEmploye  :showEmpl="dialogModalDetailEmp" :idUserCont="userIdContrat" ></detailEmploye>
                    </v-flex>
                </v-layout>


            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script>
    import detailEmploye  from "@/components/resourceHumaine/detail_employe"
    export default {
        components: {detailEmploye},
        name: "modalDetailEmploye",
        props: {
          userIdContrat:{
              type:Number
          },
          show:{
              type: Boolean,
              default: false
          }
        },
        data(){
            return {
                dialogModalDetailEmp: false
            }
        },
        methods: {
            closeDialog()
            {
                this.$emit("close");

            }
        },
        watch:{
            show: function(newValue,oldValue){
                if(newValue == true){
                    this.dialogModalDetailEmp = true
                }
                else{
                    this.dialogModalDetailEmp = false
                }
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/resourceHumaine/modalDetailEmploye.vue